export const selectors = {
	searchContainer: '.site-search',
	searchInput: '.search-form__term',
	searchInputStats: '.site-search__stats',
	searchInputStatsCount: '.site-search__stats .count',
	searchInputStatsLink: '.site-search__stats .link',
	searchClear: '.search-form__clear',
	searchAutocomplete: '.site-search__suggestions',
	searchResults: '.site-search__results',
	searchResultsSegment: '.site-search__segment',
	searchHits: '.hits',
};

export const getContainerID = (suffix) => {
	return {
		searchAutocomplete: `site-search-suggestions-${suffix}`,
		searchSearchfield: `site-search-input-${suffix}`,
		searchResultsMain: `search-results-main-${suffix}`,
		searchResultsAdditional: `search-results-additional-${suffix}`,
		searchInfinite: `site-search-infinite-scroll-${suffix}`,
	};
};

export const addSearchSiteKey = '3d6d7ec4769db2dea8f592973f6d8313';

export const getLabels = (key = '') => {
	const labels = JSON.parse(document.querySelector(selectors.searchContainer).getAttribute('data-labels'));
	if (key !== '') {
		return key in labels ? labels[key] : '';
	} else {
		return labels;
	}
};

export const isInfiniteScroll = (searchEl) => {
	const dataVal = searchEl.querySelector(selectors.searchResults).getAttribute('data-infinite');
	return dataVal !== null && dataVal !== '';
};
